class ConnectionsQueryKeys {
    prefix = 'connections';
    getConnections() {
        return [this.prefix];
    }
}
export default ConnectionsQueryKeys;
